import { IServerAdminSettings, ISiteSubscriptionSettings } from '../../../settings/interfaces/ISite';
import { Request } from './Request';

export interface IUpdateSiteSettingsForServerAdminParams {
  id: string;
  settings: IServerAdminSettings;
  subscriptionSettings?: ISiteSubscriptionSettings;
}

export interface IUpdateSiteSettingsForServerAdminResult {
}

export class UpdateSiteSettingsForServerAdminRequest extends Request<IUpdateSiteSettingsForServerAdminParams, IUpdateSiteSettingsForServerAdminResult> {
  constructor(params: IUpdateSiteSettingsForServerAdminParams) {
    super('updateSiteSettingsForServerAdmin', params);
  }
}
